import React, { useState, useEffect, useRef } from "react";
import {
    Box,
    TextField,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControlLabel,
    Checkbox,
    IconButton,
} from "@mui/material";
import Postmonger from "postmonger";
import SettingsIcon from "@mui/icons-material/Settings"; // Corrected import
import CallIcon from "@mui/icons-material/Call";
import StoreIcon from "@mui/icons-material/Store";
import InfoIcon from "@mui/icons-material/Info";

let configJSON = {}; // Global variable
let schema = null;
const connection = new Postmonger.Session();

const ViberMessageActivity = () => {
    const [viberKeyOptions, setViberKeyOptions] = useState([]);
    const [placeholders, setPlaceholders] = useState([]);
    const [selectedViberKey, setSelectedViberKey] = useState("");
    const [selectedPlaceholder, setSelectedPlaceholder] = useState("");
    const [message, setMessage] = useState("");
    const [imageURL, setImageURL] = useState("");
    const [isConfigDialogOpen, setConfigDialogOpen] = useState(false);
    const [eventDefinitionKey, setEventDefinitionKey] = useState(null);
    const [isCallToActionEnabled, setCallToActionEnabled] = useState(false);
    const [smsFallback, setSmsFallback] = useState("");
    const [smsFallbackMessage, setSmsFallbackMessage] = useState("");
    const [ctaText, setCtaText] = useState("");
    const [ctaUrl, setCtaUrl] = useState("");
    const [name, setName] = useState("");
    const [messageLifetime, setMessageLifetime] = useState(30);
    const [lifetimeUnit, setLifetimeUnit] = useState("Minutes");
    const [primaryKey, setPrimaryKey] = useState("");
    const messageBoxRef = useRef(null); // Ref for the TextField
    const placeholderRef = useRef(null); // Ref for the placeholder dropdown
    const [errors, setErrors] = useState({ viberKey: "", message: "" });

    // Determine if the environment is 'dev'
    const isDevEnv = new URLSearchParams(window.location.search).get("env") === "dev";

    useEffect(() => {
        // Initialize Postmonger event listeners
        connection.on("initActivity", (payload) => {
            onInitActivity(payload);
            connection.trigger("requestSchema"); // Ensure schema is requested after initialization
        });

        connection.on("requestedTriggerEventDefinition", onRequestedTriggerEventDefinitionHandler);
        connection.on("requestedSchema", onSchemaReceived);

        // Request necessary information
        connection.trigger("requestTriggerEventDefinition");
        connection.trigger("ready");

        //setPlaceholders(['test']);

        return () => {
            // Cleanup Postmonger listeners on component unmount
            connection.off("initActivity", onInitActivity);
            connection.off("requestedSchema", onSchemaReceived);
        };
    }, []);

    useEffect(() => {
        console.log("Message state updated:", message);
    }, [message]);

    const onInitActivity = (payload) => {
        console.log("Activity initialized:", payload);
        configJSON = payload;

        const inArguments = payload.arguments?.execute?.inArguments || [{}];
        const inArgs = inArguments[0];

        if (inArgs) {
            setName(inArgs.name || "");
            setMessage(inArgs.message || "");
            setImageURL(inArgs.imageURL || "");
            setSelectedViberKey(inArgs.viberKey || "");
            setCallToActionEnabled(!!inArgs.callToActionEnabled);
            setCtaText(inArgs.ctaText || "");
            setCtaUrl(inArgs.ctaUrl || "");
            setMessageLifetime(inArgs.messageLifetime || 45);
            setLifetimeUnit(inArgs.lifetimeUnit || "Minutes");
            setSmsFallback(!!inArgs.smsFallback);
            setSmsFallbackMessage(inArgs.smsFallbackMessage || "");
        }
    };

    const updateOrAppend = (key, value) => {
        if (!configJSON.arguments.execute.inArguments || configJSON.arguments.execute.inArguments.length === 0) {
            configJSON.arguments.execute.inArguments = [{}];
        }

        let inArgs = configJSON.arguments.execute.inArguments[0];

        if (inArgs[key]) {
            console.log(`Updating existing key: ${key}`);
            inArgs[key] = value; // Update the existing key
        } else {
            console.log(`Appending new key: ${key}`);
            inArgs[key] = value; // Append the new key
        }

        configJSON.arguments.execute.inArguments = [inArgs];
    };

    const onSchemaReceived = (data) => {
        if (!configJSON || Object.keys(configJSON).length === 0) {
            console.error("ConfigJSON is not ready yet.");
            return;
        }


        console.log("Schema received:", data);
        schema = data?.schema || [];
        const tagOptions = [];
        const phoneKeyOptions = [];
        const inArgs = {};

        // Process schema entries
        schema.forEach((item) => {
            const key = item.key;
            const type = item.type;
            const isPrimaryKey = item.isPrimaryKey;

            if (key.indexOf('.') > 0) {
                const schemaSplit = key.split('.');
                const isEventAttribute = schemaSplit.length === 3 && key.startsWith('Event');

                if (isEventAttribute) {
                    const attributeKey = schemaSplit[2];

                    // Handle attribute keys with or without spaces
                    let value = attributeKey.includes(' ')
                        ? `{{${schemaSplit[0]}.${schemaSplit[1]}.\"${attributeKey}\"}}`
                        : `{{${key}}}`;

                    if (isPrimaryKey) {
                        setPrimaryKey(value);
                    }

                    updateOrAppend(attributeKey, value);
                    if (type === 'Phone') {
                        phoneKeyOptions.push(attributeKey);
                    }
                    tagOptions.push(attributeKey);
                }
            }
        });

        // Set options for dropdowns or other UI elements
        setViberKeyOptions(phoneKeyOptions);
        setPlaceholders(tagOptions);

        // Handle viberKey from configJSON
        try {
            const viberKey = configJSON?.arguments?.execute?.inArguments?.[0]?.viberKey || '';
            if (viberKey) {
                inArgs.viberKey = viberKey;
            } else {
                console.warn("viberKey not found in configJSON.");
            }
        } catch (e) {
            console.error("Error while retrieving viberKey:", e);
        }

        console.log("updated scema attributes:", configJSON);
    };

    const onRequestedTriggerEventDefinitionHandler = (eventDefinition) => {
        console.log("Trigger Event Definition:", eventDefinition);
        setEventDefinitionKey(eventDefinition.eventDefinitionKey);
    };

    const handleSave = () => {
        const newErrors = { viberKey: "", message: "" };
        if (!selectedViberKey) {
            newErrors.viberKey = "Please select a Viber ID Key";
        }
        if (!message.trim()) {
            newErrors.message = "Please enter a message";
        }

        // if we have any errors, set them and return early
        if (newErrors.viberKey || newErrors.message) {
            setErrors(newErrors);
            return;
        }

        // if no errors, clear them
        setErrors({ viberKey: "", message: "" });

        const updatedActivity = {
            ...configJSON,
            arguments: {
                ...configJSON.arguments,
                execute: {
                    ...configJSON.arguments.execute,
                    inArguments: [
                        {
                            ...((configJSON.arguments.execute.inArguments || [])[0] || {}), // Keep the existing object or initialize it
                            viberKey: selectedViberKey, // Update or add viberKey
                            primaryKey: primaryKey || "",
                            name: name || "",
                            message: message || "",
                            imageURL: imageURL || "",
                            callToActionEnabled: isCallToActionEnabled,
                            ctaText: ctaText || "",
                            ctaUrl: ctaUrl || "",
                            messageLifetime: messageLifetime || 45,
                            lifetimeUnit: lifetimeUnit || "Minutes",
                            smsFallback: smsFallback,
                            smsFallbackMessage: smsFallbackMessage || ""
                        },
                    ],
                },
            },
            metaData: {
                ...configJSON.metaData,
                isConfigured: true,
            },
        };


        // Send updated activity back to Journey Builder
        connection.trigger("updateActivity", updatedActivity);
        console.log("Updated Activity:", updatedActivity);
    };

    const handleClose = () => {
        connection.trigger("setActivityDirtyState", false);
        connection.trigger("requestInspectorClose");
    };

    const handleAddPlaceholder = (event) => {
        if (event.target.value) {
            setMessage((prev) => `${prev} [$${event.target.value.toUpperCase()}$]`);
            setSelectedPlaceholder(""); // Reset the selected placeholder
            if (messageBoxRef.current) {
                messageBoxRef.current.focus(); // Focus the TextField
            }
            if (placeholderRef.current) {
                placeholderRef.current.blur();
            }
        }
    };

    const generateAttributeKey = (deName, attr) => {
        if (!eventDefinitionKey || !attr) return "";
        return `{{Event.${eventDefinitionKey}.${attr}}}`;
    };

    return (
        <Box sx={{
            margin: "auto",
            marginTop: "5%"
        }}>
            <Box>
                <Typography variant="h4" gutterBottom align="center">
                    Viber Integration

                    {/* Settings Icon */}
                    {isDevEnv && (
                        <IconButton
                            onClick={() => setConfigDialogOpen(true)}
                        >
                            <SettingsIcon />
                        </IconButton>
                    )}
                </Typography>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between", // Space between form and preview
                    padding: 2,
                    margin: "auto",
                }}
                fullWidth
            >
                <Box sx={{
                    flex: 2,
                    padding: "0 30px 10px 0px",
                    width: '50%'
                }}>
                    {/* Message Input */}
                    <TextField
                        fullWidth
                        label="Name"
                        placeholder="Enter Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        rows={4}
                        margin="normal"
                    />
                    {/* Viber Key Selection */}
                    <FormControl fullWidth margin="normal">
                        <InputLabel id="viber-id-select-label">Select Viber Id Key *</InputLabel>

                        <Select
                            labelId="viber-id-select-label"
                            id="viberId"
                            value={selectedViberKey}
                            onChange={(e) => setSelectedViberKey(e.target.value)}
                            label="Select Viber Id Key"
                        >
                            {viberKeyOptions.map((key, index) => (
                                <MenuItem key={index} value={key}>
                                    {key}
                                </MenuItem>
                            ))}
                        </Select>

                        {errors.viberKey
                            ? (
                                <Typography variant="caption" color="error">
                                    {errors.viberKey}
                                </Typography>
                            )
                            : (
                                <Typography variant="caption" color="textSecondary">
                                    Select the field containing mobile numbers (ViberId).
                                </Typography>
                            )
                        }
                    </FormControl>

                    {/* Placeholder Selection */}
                    <FormControl fullWidth margin="normal" variant="outlined">
                        <InputLabel id="add-placeholder-select-label">Add Personalization</InputLabel>
                        <Select
                            labelId="add-placeholder-select-label"
                            value={selectedPlaceholder}
                            onChange={handleAddPlaceholder}
                            ref={placeholderRef}
                            label="Add Personalization"
                        >
                            {placeholders.map((placeholder, index) => (
                                <MenuItem key={index} value={placeholder}>
                                    {placeholder}
                                </MenuItem>
                            ))}
                        </Select>
                        <Typography variant="caption" color="textSecondary">
                            Add Personalization to the message, e.g., [$FirstName$].
                        </Typography>
                    </FormControl>

                    {/* Message Input */}
                    <TextField
                        fullWidth
                        label="Message"
                        placeholder="Enter message text"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        multiline
                        rows={4}
                        margin="normal"
                        inputRef={messageBoxRef} 
                        required
                        error={Boolean(errors.message)}
                        helperText={errors.message || ""}
                    />

                    {/* Image URL Input */}
                    <TextField
                        fullWidth
                        label="Image URL"
                        placeholder="Enter image URL"
                        value={imageURL}
                        onChange={(e) => setImageURL(e.target.value)}
                        margin="normal"
                    />


                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginTop: 2, display: "none" }}>
                        <TextField
                            fullWidth
                            label="Message Lifetime"
                            type="number"
                            value={messageLifetime}
                            onChange={(e) => setMessageLifetime(e.target.value)}
                        />

                        <FormControl sx={{ width: '50%' }} variant="outlined">
                            <InputLabel id="unit-select-label">Unit</InputLabel>
                            <Select
                                labelId="unit-select-label"
                                id="unit-select"
                                value={lifetimeUnit}
                                onChange={(e) => setLifetimeUnit(e.target.value)}
                                label="Unit"
                            >
                                <MenuItem value="Minutes">Minutes</MenuItem>
                                <MenuItem value="Hours">Hours</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={isCallToActionEnabled}
                                onChange={(e) => setCallToActionEnabled(e.target.checked)}
                            />
                        }
                        label="Call To Action Button"
                    />

                    {isCallToActionEnabled && (
                        <Box sx={{ marginBottom: 2 }}>

                            <TextField
                                fullWidth
                                label="Text"
                                value={ctaText}
                                margin="normal"
                                onChange={(e) => setCtaText(e.target.value)}
                            />

                            <TextField
                                fullWidth
                                label="URL"
                                value={ctaUrl}
                                margin="normal"
                                onChange={(e) => setCtaUrl(e.target.value)}
                            />

                        </Box>
                    )}

                    <Box sx={{ marginTop: 2 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={smsFallback}
                                    onChange={(e) => setSmsFallback(e.target.checked)}
                                />
                            }
                            label="SMS Fallback"
                        />
                    </Box>

                    {smsFallback && (
                        <TextField
                            fullWidth
                            label="SMS Fallback Message"
                            placeholder="Enter SMS fallback message (max 670 characters)"
                            value={smsFallbackMessage}
                            onChange={(e) => setSmsFallbackMessage(e.target.value)}
                            multiline
                            rows={4}
                            margin="normal"
                            required
                            error={smsFallback && !smsFallbackMessage.trim()}
                            helperText={
                                smsFallback && !smsFallbackMessage.trim()
                                    ? "SMS Fallback message is required"
                                    : ""
                            }
                            inputProps={{ maxLength: 670 }}
                        />
                    )}
                    
                    {/* Configuration JSON Dialog */}
                    <Dialog
                        open={isConfigDialogOpen}
                        onClose={() => setConfigDialogOpen(false)}
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogTitle>Configuration</DialogTitle>
                        <DialogContent>
                            <Typography variant="body2" component="pre">
                                {JSON.stringify(configJSON, null, 2)}
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setConfigDialogOpen(false)} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>

                {/* Smartphone Preview Section */}
                {/* Mobile Frame */}
                <Box
                    sx={{
                        width: "48%",
                        height: 750,
                        background: "linear-gradient(135deg, #927BFD, #5E35B1)",
                        borderRadius: "36px",
                        padding: "16px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px 16px",
                            backgroundColor: "#f5f5f5",
                            borderBottom: "1px solid #ddd",
                            borderRadius: "12px 12px 0px 0px",
                        }}
                    >
                        <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
                            Viber Preview
                        </Typography>
                        <Box>
                            <IconButton size="small">
                                <CallIcon />
                            </IconButton>
                            <IconButton size="small">
                                <StoreIcon />
                            </IconButton>
                            <IconButton size="small">
                                <InfoIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    {/* Unified Message Box */}
                    <Box
                        sx={{
                            backgroundColor: "#fff",
                            borderRadius: "0px 0px 12px 12px",
                            padding: "16px",
                            flexGrow: 1,
                            position: "relative",
                            overflowY: "auto",
                            overflowX: "hidden",
                            height: "100%"
                        }}
                    >
                        {/* Icon at the top-left */}
                        <Box
                            sx={{
                                position: "absolute",
                                top: "16px",
                                left: "16px",
                                width: "40px",
                                height: "40px",
                                backgroundColor: "#fff",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                            }}
                        >
                            <img
                                src="/images/Appistoki-Favicon.png"
                                alt="Icon"
                                style={{ width: "30px", height: "30px", borderRadius: "50%" }}
                            />
                        </Box>

                        {/* Message */}
                        <Box
                            sx={{
                                marginLeft: "48px",
                                background: "#f0f0f0",
                                borderRadius: "0 20px 20px 20px"
                            }}
                        >
                            {/* Push content to the right of the icon */}
                            <Typography variant="body1" sx={{ padding: 2, whiteSpace: "pre-line", marginBottom: 1 }}>
                                {message}
                            </Typography>

                            {/* Image */}
                            {imageURL && (
                                <Box
                                    sx={{
                                        textAlign: "center",
                                        marginBottom: "10px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <img
                                        src={imageURL}
                                        alt="Preview"
                                        style={{
                                            width: "100%",
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        }}
                                    />
                                </Box>
                            )}

                            {/* Call-to-Action Button */}
                            {ctaText && (
                                <Box sx={{ padding: "12px" }}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        href={ctaUrl}
                                        target="_blank"
                                        sx={{
                                            backgroundColor: "#7c4dff",
                                            color: "#fff",
                                            fontWeight: "bold",
                                            textTransform: "none",
                                            borderRadius: "20px",
                                            height: "35px",
                                            padding: "10px",
                                            "&:hover": {
                                                backgroundColor: "#5e35b1",
                                            },
                                        }}
                                    >
                                        {ctaText}
                                    </Button>
                                </Box>
                            )}

                            <Box
                                sx={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    color: "#777",
                                    padding: "9px 12px 3px 9px",
                                }}
                            >
                                <Typography variant="caption">4:25 PM</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ padding: "0px 24px 24px 24px" }}>
                {/* Actions */}
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: "#9e9e9e", // Grey color
                            color: "#ffffff", // White text
                            "&:hover": {
                                backgroundColor: "#757575", // Darker grey on hover
                            }
                        }}
                        onClick={handleClose}
                    >
                        Close
                    </Button>

                    <Box sx={{ flexGrow: 1 }}></Box>

                    <Button variant="contained" color="primary" onClick={handleSave}>
                        Save
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default ViberMessageActivity;